// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./vars.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer__header {
    background-color: var(--background-color-footer);
}

.text-footer {
    color: white;
    text-decoration: none;
    font-family: var(--font-family-title);
    line-height: 1.1rem;
    font-size: 1rem;
    text-align: justify;
}

.container-departamento-asistencia{
    width: 70%;
}

.container-legales{
    margin: auto;
    width: 91%;
}

.link-item {
    margin: 12px 0px;
    text-align: start
}

.footer__social-home {
    width: 40px;
    height: 40px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 76%;
    margin-right: 10px;
    border-radius: 50%;
    cursor: pointer;
}

.imagen_SSN{
    max-width: 14rem;
}

.politicas{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.footer_politicas_2{
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 4px 5vw;
}


@media screen and (max-width: 1049px) {
    .container_imagen_ssn{
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }
    .politicas{
        display: flex;
        justify-content: flex-start;
        width: 100%;
        align-items: flex-start;
    }

    .politica{
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }

    .imagen_SSN{
        max-width: 12rem;
    }
}

@media screen and (max-width: 600px) {
    .footer_politicas_2 {
        justify-content: space-evenly;
        flex-direction: column;
        align-items: flex-start;
    }

    .lista-links {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .container-seguinos {
        display: flex;
        flex-direction: column;
    }

    .container_links_legales {
        display: flex;
        padding-right: 0px !important;
        flex-direction: column;
    }

    .politicas {
        flex-direction: column;
        width: 93%;
        text-align: start;
    }
}

@media screen and (min-width: 1050px) {
    .footer_politicas_2 {
        display: flex;
        flex-direction: row;
        align-content: flex-start;
        align-items: center;
        padding: 4px 5vw;
    }

    .container_links_legales{
        padding-left: 70px;
        flex-direction: column;
        align-content: flex-start;
        flex-wrap: wrap;
    }
}

.buttons-social {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.container-lista{
    margin-bottom: 1rem;
}

.container_links_legales {
    display: flex;
    padding-right: 25px;
    width: 100%;
    gap: 1rem;
}

.footer__logo {
    margin: 0 0 5px 0;
    max-width: 134px;
    max-height: 52px;
}

.container-footer {
    background-color: var(--color-sura);
    display: flex;
    flex-direction: column;
    display: flex;
    flex-direction: column;
    padding: 20px 0px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Footer.css"],"names":[],"mappings":"AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;;;AAGA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,WAAW;IACf;IACA;QACI,aAAa;QACb,2BAA2B;QAC3B,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,2BAA2B;QAC3B,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,yBAAyB;QACzB,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB","sourcesContent":["@import url(vars.css);\r\n\r\n.footer__header {\r\n    background-color: var(--background-color-footer);\r\n}\r\n\r\n.text-footer {\r\n    color: white;\r\n    text-decoration: none;\r\n    font-family: var(--font-family-title);\r\n    line-height: 1.1rem;\r\n    font-size: 1rem;\r\n    text-align: justify;\r\n}\r\n\r\n.container-departamento-asistencia{\r\n    width: 70%;\r\n}\r\n\r\n.container-legales{\r\n    margin: auto;\r\n    width: 91%;\r\n}\r\n\r\n.link-item {\r\n    margin: 12px 0px;\r\n    text-align: start\r\n}\r\n\r\n.footer__social-home {\r\n    width: 40px;\r\n    height: 40px;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n    background-size: 76%;\r\n    margin-right: 10px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.imagen_SSN{\r\n    max-width: 14rem;\r\n}\r\n\r\n.politicas{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n}\r\n\r\n.footer_politicas_2{\r\n    display:flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    padding: 4px 5vw;\r\n}\r\n\r\n\r\n@media screen and (max-width: 1049px) {\r\n    .container_imagen_ssn{\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        width: 100%;\r\n    }\r\n    .politicas{\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        width: 100%;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .politica{\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        width: 100%;\r\n    }\r\n\r\n    .imagen_SSN{\r\n        max-width: 12rem;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n    .footer_politicas_2 {\r\n        justify-content: space-evenly;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .lista-links {\r\n        display: flex;\r\n        justify-content: flex-start;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .container-seguinos {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .container_links_legales {\r\n        display: flex;\r\n        padding-right: 0px !important;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .politicas {\r\n        flex-direction: column;\r\n        width: 93%;\r\n        text-align: start;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1050px) {\r\n    .footer_politicas_2 {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-content: flex-start;\r\n        align-items: center;\r\n        padding: 4px 5vw;\r\n    }\r\n\r\n    .container_links_legales{\r\n        padding-left: 70px;\r\n        flex-direction: column;\r\n        align-content: flex-start;\r\n        flex-wrap: wrap;\r\n    }\r\n}\r\n\r\n.buttons-social {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.container-lista{\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.container_links_legales {\r\n    display: flex;\r\n    padding-right: 25px;\r\n    width: 100%;\r\n    gap: 1rem;\r\n}\r\n\r\n.footer__logo {\r\n    margin: 0 0 5px 0;\r\n    max-width: 134px;\r\n    max-height: 52px;\r\n}\r\n\r\n.container-footer {\r\n    background-color: var(--color-sura);\r\n    display: flex;\r\n    flex-direction: column;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 20px 0px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
